import { Row, Col, Card, Typography, Space } from 'antd';
import { Check } from 'lucide-react';

const { Title, Paragraph, Text } = Typography;

export function Embed() {
  const options = ['React Widget', 'JavaScript SDK', 'REST API', 'GraphQL API'];

  return (
    <section
      style={{
        padding: '80px 24px',
        backgroundColor: '#001529',
        color: '#ffffff',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <Row gutter={[48, 48]} align="middle">
          {/* Left Column */}
          <Col xs={24} md={12}>
            <Title
              level={2}
              style={{
                color: '#ffffff',
                fontSize: 'clamp(28px, 4vw, 40px)',
                marginBottom: '24px',
                fontWeight: 700,
              }}
            >
              Embed Anywhere
            </Title>
            <Paragraph
              style={{
                color: 'rgba(255, 255, 255, 0.85)',
                fontSize: '18px',
                marginBottom: '32px',
              }}
            >
              Integrate seamlessly with React, JavaScript, REST API, or GraphQL
            </Paragraph>
            <Space
              orientation="vertical"
              size="middle"
              style={{ width: '100%' }}
            >
              {options.map((tech) => (
                <div
                  key={tech}
                  style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
                >
                  <Check size={18} style={{ color: '#52c41a' }} />
                  <Text
                    style={{
                      color: 'rgba(255, 255, 255, 0.9)',
                      fontSize: '16px',
                    }}
                  >
                    {tech}
                  </Text>
                </div>
              ))}
            </Space>
          </Col>

          {/* Right Column (Code View) */}
          <Col xs={24} md={12}>
            <Card
              variant="borderless"
              styles={{
                body: {
                  background: '#141414',
                  borderRadius: '12px',
                  border: '1px solid #303030',
                  padding: '24px',
                  fontFamily: 'monospace, Courier, Courier New',
                  fontSize: '14px',
                  lineHeight: '1.6',
                },
              }}
            >
              <div style={{ color: '#52c41a' }}>// React Integration</div>
              <div style={{ color: '#8c8c8c', marginTop: '8px' }}>
                import {'{ SubscriptionWidget }'} from '@isubscribe/react';
              </div>
              <div style={{ marginTop: '16px', color: '#1677ff' }}>
                &lt;SubscriptionWidget
              </div>
              <div style={{ color: '#1677ff', paddingLeft: '16px' }}>
                tenant=<span style={{ color: '#d89614' }}>"acme"</span>
              </div>
              <div style={{ color: '#1677ff', paddingLeft: '16px' }}>
                theme=<span style={{ color: '#d89614' }}>"dark"</span>
              </div>
              <div style={{ color: '#1677ff' }}>
                &gt;&lt;/SubscriptionWidget&gt;
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </section>
  );
}
